import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'

export class HtmlCell extends GridCell {
  public render() {
    return <td>
      <div style={this.props.dataItem.styles || {}}>
        {this.props.dataItem.type === 'Lead Text' ?
        <span className="html-content" dangerouslySetInnerHTML={{ __html: this.props.dataItem[this.props.field]}}/> :
        <a target="_blank"
         href={this.props.dataItem.target_url || this.props.dataItem.url}>{this.props.dataItem[this.props.field]}</a>
         }
      </div>
    </td>}
}



// WEBPACK FOOTER //
// ./src/pages/content-calendar/render/html_cell.tsx